import React from "react";
import { Route, Routes } from "react-router-dom";
import { SCREEN_PATH } from "../../constants/global.constants";

import Login from "../../views/login/Login";
import Reset from "../../views/auth-forms/ResetForm";
import EmailVerification from "../../views/auth-forms/EmailVerification";
import PrivacyPolicy from "../../views/privacy-policy/PrivacyPolicy";

const PublicRoute = ({ isAuthenticated }) => {
  return (
    <Routes>
      {!isAuthenticated && (
        <>
          <Route exact path={SCREEN_PATH.LOGIN} element={<Login />} />
          <Route path={SCREEN_PATH.PRIVACY_POLICY} exact element={<PrivacyPolicy />} />
        </>
      )}
      <Route path={SCREEN_PATH.RESET_PASSWORD} exact element={<Reset />} />
      <Route
        path={SCREEN_PATH.EMAIL_VERIFICATION}
        exact
        element={<EmailVerification />}
      />
    </Routes>
  );
};
export default PublicRoute;
